export const AccentLineAnimation = (function () {
	'use strict';

	function init() {
		const lineElements = document.querySelectorAll('[data-accent-line]')
		if (!lineElements.length) {
			return
		}
		const lines = []
		const onScroll = () => {
			const midY = window.scrollY + (window.innerHeight * 0.5)
			lines.forEach((line) => {
				let progress = 1
				if (line.top > midY) {
					progress = 0
				} else if ((line.top + line.height) < midY) {
					progress = 1
				} else {
					progress = (midY - line.top) / line.height
				}
				progress = window.EasingFunctions[line.easing](progress)
				const dashOffset = line.length - (line.length * progress)
				line.path.setAttribute('stroke-dashoffset', dashOffset)
				line.el.setAttribute('preserveAspectRatio', 'none')
				line.path.setAttribute('vector-effect', 'non-scaling-stroke')
			})
		}
		const updatePosition = (line, index) => {
			const isFirst = index < 2
			const path = line.path
			const rect = line.el.getBoundingClientRect()
			const pRect = path.getBoundingClientRect()
			const xScale = (pRect.width / path.getBBox().width) * 1.15
			const topAdjust = isFirst ? window.innerHeight * 0.35 : 0
			line.top = rect.top + window.scrollY + topAdjust
			line.height = rect.height//  - topAdjust
			line.length = path.getTotalLength() * xScale
			path.setAttribute('stroke-dasharray', line.length)
		}
		const onResize = () => {
			console.log('resize', document.body.scrollHeight)
			lines.forEach(updatePosition)
			onScroll()
		}
		lineElements.forEach((el) => {
			const path = el.querySelector('path')
			const easing = el.getAttribute('data-accent-line') || 'linear'
			let length, top, height = 0
			const line = { el, path, length, top, height, easing }
			lines.push(line)
		})
		// custom event fired from app.js
		window.addEventListener('px-debounced-resize', onResize, { capture: true, passive: true })
		window.addEventListener('scroll', onScroll, { capture: true, passive: true })
	}

	return {
		init: init,
	};
})();
